<script setup lang="ts">
interface IProps {
    isLazy?: boolean;
    canLoad?: boolean;
}

const { isLazy, canLoad } = defineProps<IProps>();

defineOptions({
    inheritAttrs: false,
});

const root = ref<HTMLDivElement>();

const slots = useSlots();

const mountedLazily = ref(!isLazy);

const showLoading = computed(
    () => !mountedLazily.value || !slots.default || !canLoad
);

if (isLazy) {
    const { stop } = useIntersectionObserver(root, ([{ isIntersecting }]) => {
        mountedLazily.value ||= isIntersecting;
    });
    watch(showLoading, value => {
        if (!value) {
            stop();
        }
    });
}

defineExpose({
    root,
});
</script>
<template>
    <div ref="root" class="lazy-mount" v-bind="$attrs">
        <slot v-if="showLoading" name="loading" />
        <slot v-else />
    </div>
</template>

<style lang="scss" scoped>
.lazy-mount {
    width: 100%;
}
</style>
